import { record } from 'fp-ts';
import { WithEnterpriseId, WithServiceId } from '@mews-commander/types';
import { FilterFormValues } from '../schemas';
import { getFilterViewResourceParams } from '../utils';
import { useRateGroupGetQuery } from '../../rateGroups';
import { useRateGetQuery } from '../../rates';

interface UseViewTypeNameParams extends WithServiceId, WithEnterpriseId {
    view: FilterFormValues['view'];
}

export const useViewTypeName = ({ view, enterpriseId, serviceId }: UseViewTypeNameParams) => {
    const { rateGroupId, rateId } = getFilterViewResourceParams(view);
    const enterpriseIds = [enterpriseId];
    const serviceIds = [serviceId];

    const { data: rateGroup, isFetching: isRateGroupFetching } = useRateGroupGetQuery(
        {
            enterpriseIds,
            rateGroupId: rateGroupId || '',
            serviceIds,
        },
        { enabled: !!rateGroupId }
    );

    const { data: rate, isFetching: isRateFetching } = useRateGetQuery(
        {
            enterpriseIds,
            rateId: rateId || '',
            serviceIds,
        },
        { enabled: !!rateId }
    );

    if (view.type === 'rate') {
        return {
            name: rate?.name,
            names: getNames(rate?.externalNames),
            isFetching: isRateFetching,
        };
    }

    return {
        name: rateGroup?.name,
        names: getNames(rateGroup?.names),
        isFetching: isRateGroupFetching,
    };
};

const getNames = <T,>(names?: Record<string, T>) => (names && !record.isEmpty(names) ? names : undefined);
